export const language: any ={
  main: "Trang chủ",
  ingredients: "Nguyên Liệu",
  ai_chef: "Đầu bếp AI",
  favorites: "Yêu thích",
  menu: "Menu",
  get_start: "Bắt đầu",
  title_first_1: "AI gợi ý công thức nấu ăn theo độ tuổi",
  title_second_1: "Sắp xếp hoàn hảo từ thực đơn cho đến công thức nấu ăn",
  content_1: "Ngưng lo lắng về thực đơn và calo hàng ngày, Từ bây giờ hãy nhận gợi ý từ Hey! Cooker",
  title_first_2: "Hôm nay trời se lạnh, bạn đã vất vả rồi.",
  title_second_2: "Sau khi tan làm, ăn canh quân đội thì bạn thấy sao?",
  content_2: "Hãy tìm thịt hộp và mì ăn liền còn lại trong tủ lạnh và cùng làm món tối đơn giản nhé!",
  my_food_ingredients: "Bạn đang không biết nấu món gì? ",
  btn_add_photo: "Chọn hình ảnh hoặc chụp ảnh",
  my_food_reason: "Hãy chọn nguyên liệu sẵn có của bạn",
  btn_get_cooking: "Nhận đề xuất món ăn AI",
  enriching_title: "Làm phong phú cơ thể và tâm trí của bạn",
  enriching: "Tuyển tập các công thức nấu ăn",
  photo_registration_title: "Đầu bếp AI đã sẵn sàng <br/>đề xuất món ăn cho bạn.",
  photo_registration_content: `Sử dụng AI để nhận diện nguyên liệu<br/>và phân tích công thức để tận hưởng <br/>niềm vui nấu ăn nhiều hơn!`,
  food_suggestions_title: "Bạn đang lo lắng không biết nên ăn gì?",
  food_suggestions_sub_title: "Món ăn theo chủ đề",
  our_interests_title: "Cùng lên thực đơn phù hợp cho bản thân và gia đình.",
  our_interests_sub_title: "Hãy giúp Hey! Cooker hiểu thêm về bạn",
  favorite_title: "Sổ tay nấu ăn đa dạng",
  weather_title: "Món ăn phù hợp với thời tiết se lạnh",
  video_title: "Kiểm tra bằng video sống động",
  tag: {
    close: "Thu gọn",
    open: "Mở rộng"
  },
  no_data: "Không có dữ liệu",
  update_version_submit: "Cập nhật ngay",
  update_version_title: "Có phiên bản mới",
  update_version_content: "Vui lòng cập nhật lên phiên bản mới nhất của ứng dụng để có môi trường sử dụng tối ưu.",
  close_btn: "Đóng",
  not_video_id: "Video không tồn tại",
  favorite_login: "Đăng nhập hoặc đăng ký để lưu danh sách công thức nấu ăn yêu thích của bạn.",
  view_recipe: "Xem các công thức từ nguyên liệu đã chọn",
  my_ingredient: "Nguyên liệu của tôi",
  add_ingredient: "Thêm nguyên liệu của tôi",
  favorite_section_title: "Đừng quên xem lại các công thức đã lưu",
  favorite_section_description: "Công thức yêu thích của tôi",
  discover:"Khám phá",
  my_cooker:"Bếp của tôi",
  video_section_title: "Khám phá và cảm nhận bằng video",
  // video_section_description: "✌Video nấu ăn được đề xuất",
  video_section_description: "Video nấu ăn được đề xuất",
  age_10: "U10",
  age_10_to_20: "10-20 tuổi",
  age_20_to_30: "20-30 tuổi",
  age_30_to_40: "30-40 tuổi",
  age_40_to_50: "40-50 tuổi",
  age_more_50: "50+",
  weather_title1: "Gợi ý hôm nay",
  weather_title2: "Ngày mưa se lạnh ăn gì được nhỉ",
  tasteSuggestion1: "Thỏa mãn vị giác",
  tasteSuggestion2: "Hương vị dành riêng cho bạn",
  tasteTitle1: "Cay nồng <br />hấp dẫn",
  tasteDescription1: "#xao #nuong #ngaymua",
  tasteTitle2: "Tươi mới, <br />thanh đạm",
  tasteDescription2: "#tuoi #chatxo #ankieng",
  tasteDescription3: "#chua #ngot #kichthich",
  tasteDescription4: "#đặcbiệt #hạt #bíthuật",
  tasteDescription5: "#vị #dinhdưỡng #cảm giác",
  tasteTitle3: "Vị chua <br />kích thích",
  tasteTitle4: "Thơm - ngon <br />ngọt",
  tasteTitle5: "Hòa trộn và <br />lôi cuốn",
  suggest_section_title: "Hey! Cooker sẽ giúp bạn lựa chọn",
  suggest_section_description: "Chủ đề mà bạn quan tâm là gì?",
  suggest_item_title1: "Món ăn đơn giản",
  suggest_item_description1: `Công thức đơn giản<br/> cho buổi sáng và buổi<br/> trưa`,
  suggest_item_title2: "Ăn kiêng",
  suggest_item_description2: `Ngon tuyệt với chế độ<br/> ăn ít tinh bột`,
  suggest_item_title3: "Món ăn cuối năm",
  suggest_item_description3: `Món ăn cho bữa tiệc tại<br/> gia`,
  suggest_item_title4: "Thực phẩm<br/> lành mạnh",
  suggest_item_description4: `Tạo thể chất và tinh<br/> thần khỏe mạnh`,
  suggest_item_title5: "Ăn nhẹ đơn giản",
  suggest_item_description5: `Món ăn nhẹ đồng hành<br/> khi uống rượu một<br/> mình`,
  history: "Lịch sử phân tích hình ảnh",
  community: {
    sub_title: "Nấu ăn cùng mọi người",
    title: "Khám phá cộng đồng Hey! Cooker",
    trending: "Xu hướng",
    follow: "Đang theo dõi",
    video: "Video",
    discover :"Khám phá",
    no_data: "Chưa có cập nhật mới từ cộng đồng Hey! Cooker",
    discover_post: "Khám phá thêm bài viết từ cộng đồng",
  },
  user_suggest_title1: "Gợi ý hôm nay",
  user_suggest_title2: "Đề xuất công thức ngẫu nhiên",
}


